<app-breadcrumb></app-breadcrumb>

<form [formGroup]="formGroup">
  <p-panel header="Upload">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-5 lg:col-5">
          <label class="bpaas-required">
            {{ 'label.file-name' | translate }} ( {{ 'label.maximum-file-szie' | translate: { maxFileSize: maxFileSize } }} )
          </label>
          <div class="p-inputgroup">
            <input type="text" pInputText
              formControlName="fileName"
              [id]="parseToId('fileName')"
              readonly="readonly"
              [ngClass]="{'ng-dirty': formControlInvalid('fileName') }">
            <p-fileUpload
              #fileUploadComponent
              mode="basic"
              chooseLabel="{{ 'button.choose-file' | translate }}"
              name="demo[]"
              accept=".csv,.xls,.xlsx,.xlsb,.txt"
              [customUpload]="true"
              [auto]="true"
              (uploadHandler)="fileUploadHandler($event, 'fileName', sheetNameOptions)">
            </p-fileUpload>
          </div>
          <div *ngIf="formControlInvalid('fileName')">
            <small class="p-error"
              *ngIf="formControl('fileName').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
            <small class="p-error"
              *ngIf="formControl('fileName').errors?.['invalidFileSize']">
              {{ 'message.validation.invalid-file-size' | translate: { maxFileSize: maxFileSize } }}
            </small>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <label class="bpaas-required">
            {{ 'label.sheet-name' | translate }}
          </label>
          <p-dropdown
            [options]="sheetNameOptions"
            optionLabel="label"
            optionValue="value"
            emptyMessage="{{ 'table.no-records-found' | translate }}"
            appendTo="body"
            (onChange)="destroyJExcel()"
            formControlName="sheetName" [inputId]="parseToId('sheetName')"
            [ngClass]="{'ng-dirty': formControlInvalid('sheetName')}">
          </p-dropdown>
          <div *ngIf="formControlInvalid('sheetName')">
            <small class="p-error"
              *ngIf="formControl('sheetName').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </div>
      </div>
      <div class="grid p-fluid justify-content-end bpaas-button-row">
        <div class="col-12 md:col-3 lg:col-2">
          <button type="button" pButton label="{{ 'button.preview' | translate }}"
            class="p-button-outlined mr-2" (click)="preview('sheetName')"
            [disabled]="sheetNameOptions.length == 0"
            [id]="parseToId('btnPreview')"></button>
        </div>
        <div class="col-12 md:col-3 lg:col-2">
          <button type="button" pButton label="{{ 'button.upload' | translate }}"
            (click)="upload()" [id]="parseToId('btnUpload')"></button>
        </div>
      </div>
    </div>
  </p-panel>
</form>

<ng-container *ngIf="showPreview">
  <p-panel header="{{ 'label.content-preview' | translate }}">
    {{ 'label.content-preview-hint' | translate: { maxRow: maxRow } }}
    <div #spreadsheet class="bpaas-jexcel-container"></div>
  </p-panel>
</ng-container>
